module.exports = __webpack_public_path__ + "static/media/a.45b8913d.png";